/**
 * Преобразует строку в kebab-case: нижний регистр, пробелы и подчёркивания — в дефисы, границы camelCase — тоже.
 * @param value — исходная строка
 */
export function toKebabCaseString(value: string): string {
  return value
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
}
